import React from "react";
import BootstrapSlider from "./BootstrapSlider";

function Laika(props) {
  const slidesLaika = [
    {
      url: "/Laika/Laika1.png",
      tip:
        "Make sure that your title matches your skills. E.g., if you’re an entry level PHP developer, don’t say that you’re a PHP Expert. Skip the abbreviations and titles – keep it short and modest.Be concise and easy to understand. Don’t use overdone motivational quotes about work ethics and inspiration, try to make the ‘about’ section as personal and as reflective of you as possible.Use the new “Open for business” feature. State your area of expertise and industry, to let recruiters know they can reach you. Don’t write in things that you wouldn’t like to happen.",
    },
    {
      url: "/Laika/Laika2.png",
      tip:
        "Tip: Add connections from the same field of work as you; even people you don’t know personally. That way, recruiters have a bigger chance of coming across your profile.Put in the skills you are most experienced in, so you can be endorsed from other people.Tip: Ask friends and coworkers to endorse you.",
    },
    {
      url: "/Laika/Laika3.png",
      tip:
        "Explain every work experience you’ve had in detail – what were your obligations and tasks, what was your job title, which technologies and tools did you use etc.Don’t be shy on listing experience that isn’t connected to your current profession.Volunteering at a local community center, summer jobs, projects you were a part of, pro bono work you did to improve your skills and gain experience – everything counts.You can help someone, and at the same time enrich your portfolio.",
    },
    {
      url: "/Laika/Laika4.png",
      tip:
        "List all your relevant accomplishments. Don’t say you have a black belt in karate, but mention an award from a hackaton.",
    },
    {
      url: "/Laika/Laika5.png",
      tip:
        "Be realistic when choosing the reason why you have a portfolio on Laika. This will help recruiters know whether you are suitable for the position on the long run.",
    },
  ];

  return (
    <div className="container-fluid">
      <div
        className="Linkedin"
        style={{ backgroundImage: "url(/images/background.png)" }}
      >
        <div className="row mx-0">
          <div className="col bg-white">
            <div className="row">
              <div className="col-md-10 offset-md-1 setHeight">
                <div>
                  <BootstrapSlider
                    slides={slidesLaika}
                    handleHover={props.handleHover}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Laika;
